var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeartBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_920_32123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21C11.8684 21.0008 11.7379 20.9756 11.6161 20.9258C11.4943 20.876 11.3834 20.8027 11.29 20.71L3.51999 12.93C2.54536 11.9452 1.99866 10.6156 1.99866 9.23002C1.99866 7.84445 2.54536 6.51484 3.51999 5.53002C4.50226 4.55053 5.83283 4.00049 7.21999 4.00049C8.60716 4.00049 9.93773 4.55053 10.92 5.53002L12 6.61002L13.08 5.53002C14.0623 4.55053 15.3928 4.00049 16.78 4.00049C18.1672 4.00049 19.4977 4.55053 20.48 5.53002C21.4546 6.51484 22.0013 7.84445 22.0013 9.23002C22.0013 10.6156 21.4546 11.9452 20.48 12.93L12.71 20.71C12.6166 20.8027 12.5057 20.876 12.3839 20.9258C12.2621 20.9756 12.1316 21.0008 12 21ZM7.21999 6.00002C6.79667 5.9981 6.37717 6.0802 5.9858 6.24155C5.59443 6.40291 5.23897 6.64031 4.93999 6.94002C4.33605 7.54714 3.99703 8.36866 3.99703 9.22502C3.99703 10.0814 4.33605 10.9029 4.93999 11.51L12 18.58L19.06 11.51C19.6639 10.9029 20.003 10.0814 20.003 9.22502C20.003 8.36866 19.6639 7.54714 19.06 6.94002C18.4437 6.35773 17.6279 6.03331 16.78 6.03331C15.9321 6.03331 15.1163 6.35773 14.5 6.94002L12.71 8.74002C12.617 8.83375 12.5064 8.90814 12.3846 8.95891C12.2627 9.00968 12.132 9.03581 12 9.03581C11.868 9.03581 11.7373 9.00968 11.6154 8.95891C11.4936 8.90814 11.383 8.83375 11.29 8.74002L9.49999 6.94002C9.20102 6.64031 8.84556 6.40291 8.45419 6.24155C8.06282 6.0802 7.64332 5.9981 7.21999 6.00002Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_920_32123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartBlack);
export default __webpack_public_path__ + "static/media/icon_heart_black.2fc3cb45c32b01ac53a03ac2e7e6b2f4.svg";
export { ForwardRef as ReactComponent };